import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { invitations } from 'gipsy-api'
import { handleAPIError } from 'features/app/store/actions'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      handleAPIError
    },
    dispatch
  )
})

export default function wrapper(Component) {
  class InviteRequestPageContainer extends PureComponent {
    constructor(props) {
      super(props)

      let email = ''
      if (props.location && props.location.state) {
        email = this.props.location.state.email
      }

      this.state = {
        email: email,
        submitted: false
      }
    }

    onChange = ({ paramName, value }) => {
      this.setState({
        [paramName]: value
      })
    }

    onSubmit = async e => {
      e.preventDefault()
      try {
        await invitations.requestInvite(this.state.email)
        this.setState({ submitted: true })
      } catch (err) {
        this.props.actions.handleAPIError(err, this.state.email)
      }
    }

    render() {
      return <Component {...this.state} {...this.props} onChange={this.onChange} onSubmit={this.onSubmit} />
    }
  }

  const containerRedux = connect(
    null,
    mapDispatchToProps,
    null,
    {
      pure: true
    }
  )(InviteRequestPageContainer)
  return containerRedux
}



// WEBPACK FOOTER //
// ./src/pages/inviteRequestPage/container.js